import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    const routeSEO = {
      '/': {
        title: "Best Software Company in Kolkata | Top AI & Software Development | Hungry Top",
        description: "Hungry Top Technologies is recognized as the best software company in Kolkata, West Bengal, India. We build enterprise software platforms, AI applications, fintech products (PaperLoan), SaaS solutions, and mobile/web apps.",
        keywords: "best software company in kolkata, top software development company in kolkata, best AI company in kolkata, IT company in kolkata, software company kolkata west bengal, custom software development kolkata, best web development company in kolkata, PaperLoan FinTech, Hungry Top Technologies",
      },
      '/services': {
        title: "Best Software Development Services in Kolkata | AI & Web Engineering",
        description: "Looking for the best software development company in Kolkata? Hungry Top offers enterprise custom software engineering, AI/ML models, FinTech platforms, and cloud microservices.",
        keywords: "best software development services kolkata, software engineering company kolkata, AI development services kolkata, custom web app development kolkata, fintech software services India",
      },
      '/products': {
        title: "Top SaaS Products & FinTech Company in Kolkata | PaperLoan",
        description: "Built by the best software company in Kolkata: PaperLoan FinTech Digital Lending Engine and HungryTop Omnichannel Restaurant Commerce Suite.",
        keywords: "PaperLoan FinTech Kolkata, best software company in kolkata products, restaurant POS software Kolkata, digital lending engine India, HungryTop SaaS",
      },
      '/industries': {
        title: "Software Solutions Across Industries | Best Software Company Kolkata",
        description: "Delivering bespoke enterprise software for FinTech, Healthcare AI, Logistics, High-Frequency Capital Markets, E-Commerce, IoT EV Fleets, and Cyber Security in Kolkata & Globally.",
        keywords: "best software company in kolkata industries, healthcare AI software Kolkata, fintech software developers Kolkata, enterprise ERP software India",
      },
      '/technologies': {
        title: "Modern Tech Stack & Architecture | Best IT Company in Kolkata",
        description: "Hungry Top Technologies leverages React, Next.js, Node.js, Python AI, PyTorch, C++ DPDK, Rust, Kafka, Kubernetes, PostgreSQL, and Pinecone Vector DB.",
        keywords: "best software company in kolkata tech stack, React developers Kolkata, Python AI developers Kolkata, Kafka microservices India, low latency C++ engineering",
      },
      '/about': {
        title: "About Hungry Top Technologies | Best Software Company in Kolkata",
        description: "Hungry Top Technologies Limited is the premier software development and AI engineering company headquartered in Kolkata, West Bengal, India.",
        keywords: "best software company in kolkata about, top IT company Kolkata, software engineering leaders Kolkata, HungryTop Technologies Kolkata HQ",
      },
      '/careers': {
        title: "Software Jobs in Kolkata | Best Software Company in Kolkata Careers",
        description: "Join the best software company in Kolkata! Explore career opportunities for Senior Full-Stack Engineers, AI Specialists, DevOps Engineers, and Product Managers at Hungry Top.",
        keywords: "software engineer jobs kolkata, best software company in kolkata hiring, IT jobs Kolkata, AI developer careers Kolkata, HungryTop careers",
      },
      '/contact': {
        title: "Contact Best Software Company in Kolkata | Hire Developers | Hungry Top",
        description: "Contact Hungry Top Technologies, the best software company in Kolkata, West Bengal. Consult our software architects for enterprise software, AI, or fintech projects.",
        keywords: "contact best software company in kolkata, hire software developers Kolkata, IT consultation Kolkata, HungryTop Technologies contact number address",
      },
      '/team': {
        title: "Leadership & Engineering Team | Best Software Company in Kolkata",
        description: "Meet the visionary leaders and senior systems engineers driving software engineering innovation at Hungry Top Technologies Limited in Kolkata.",
        keywords: "HungryTop team Kolkata, software architects Kolkata, tech leaders Kolkata West Bengal",
      },
      '/terms-and-conditions': {
        title: "Terms and Conditions | Best Software Company in Kolkata",
        description: "Read the official terms and conditions governing the use of Hungry Top Technologies software services and digital platforms.",
        keywords: "HungryTop terms and conditions, software service terms Kolkata",
      },
      '/privacy-policy': {
        title: "Privacy Policy & Data Security | Hungry Top Technologies Kolkata",
        description: "Hungry Top Technologies privacy policy outlining strict GDPR, HIPAA, and SOC2 compliant data protection standards.",
        keywords: "HungryTop privacy policy, data security Kolkata, GDPR compliance India",
      },
      '/help': {
        title: "Help Center & Documentation | Best Software Company in Kolkata",
        description: "Find support, FAQs, and developer documentation for Hungry Top Technologies software platforms and SaaS products.",
        keywords: "HungryTop help center, software documentation Kolkata, technical support FAQ",
      },
    };

    const currentSEO = routeSEO[path] || routeSEO['/'];

    // Update document title
    document.title = currentSEO.title;

    // Update meta tags dynamically
    const updateMetaTag = (name, property, content) => {
      let selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute('content', content);
      } else {
        element = document.createElement('meta');
        if (name) element.setAttribute('name', name);
        if (property) element.setAttribute('property', property);
        element.setAttribute('content', content);
        document.head.appendChild(element);
      }
    };

    updateMetaTag('title', null, currentSEO.title);
    updateMetaTag('description', null, currentSEO.description);
    updateMetaTag('keywords', null, currentSEO.keywords);
    updateMetaTag(null, 'og:title', currentSEO.title);
    updateMetaTag(null, 'og:description', currentSEO.description);
    updateMetaTag(null, 'og:url', `https://www.hungrytop.com${path}`);
    updateMetaTag('twitter:title', null, currentSEO.title);
    updateMetaTag('twitter:description', null, currentSEO.description);

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `https://www.hungrytop.com${path}`);
    }
  }, [location.pathname]);

  return null;
};

export default SEOManager;
